<template>
  <div>
    <informacoes-historico 
      v-if="($root.isGestor || $root.isAdmin) && idUsuario"
      :usuarioId="idUsuario"
    >
    </informacoes-historico>
    <selecionar-periodo-datas
      :set-date-callback="setarDatas"
      :change-date-callback="getApontamentos"
    ></selecionar-periodo-datas>
    <tabela-historico  
      :apontamentos="apontamentos"
      :carregando="carregando"
      :datas="datas"
    ></tabela-historico>
    <notifications group="historico" />
  </div>
</template>

<script>
import moment from 'moment';

import SelecionarPeriodoDatas from './partials/SelecionarPeriodoDatas';
import TabelaHistorico from './partials/TabelaHistorico';
import InformacoesHistorico from './partials/InformacoesHistorico';
import Uteis from '@/mixins/utils.js';
import get from 'lodash/get';

export default {
  name: 'HistoricoLancamentos',

  components: {
    SelecionarPeriodoDatas,
    TabelaHistorico,
    InformacoesHistorico
  },

  mixins: [
    Uteis,
  ],

  data() {
    return {
      idUsuario: null,
      apontamentos: [],
      carregando: false,
      datas: {
        inicio: null,
        fim: null,
      },
    }
  },

  mounted() {
    this.idUsuario = get(this.$route, 'params.id', null);
  },
  
  methods: {
    async getApontamentos() {
      this.$events.$emit('loading', true);

      try {
        const { data: response } = await this.$http.get('/apontamento/historico', {
          params: {
            data_inicio: moment(this.datas.inicio).format('YYYY-MM-DD'),
            data_fim: moment(this.datas.fim).format('YYYY-MM-DD'),
            usuario_id: (this.$root.isGestor || this.$root.isAdmin) ? this.idUsuario : null
          }
        });

        this.apontamentos = response.apontamentos;
      } catch(e) {
        console.error(e);
        this.notificar('Ocorreu um erro ao carregar o histórico de apontamentos.', 'historico');
      } finally {
        this.$events.$emit('loading', false);
      }
    },

    setarDatas(datas) {
      this.datas = { ...datas };
    }
  },
}
</script>